export { default } from "./Badge.js";
